import {
  Gavel,
  FileText,
  Plus,
  LayoutGrid,
} from 'lucide-react';

export type TabId = 'all' | 'auctions' | 'proposals' | 'create';

export interface Tab {
  id: TabId;
  label: string;
  href: string;
  icon: typeof Gavel;
}

export const TABS: Tab[] = [
  {
    id: 'all',
    label: 'All Events',
    href: '/sourcing',
    icon: LayoutGrid,
  },
  {
    id: 'auctions',
    label: 'Reverse Auctions',
    href: '/sourcing/auctions',
    icon: Gavel,
  },
  {
    id: 'proposals',
    label: 'Sealed Proposals',
    href: '/sourcing/proposals',
    icon: FileText,
  },
  {
    id: 'create',
    label: 'Create Event',
    href: '/sourcing/create',
    icon: Plus,
  },
];
